import React from 'react'

import Consultant from 'components/Consultant'

const ConsultantPage = ({ match: { params: { consultantId } } }) => (
  <Consultant consultantId={consultantId} />
)

export default ConsultantPage



// WEBPACK FOOTER //
// ./src/pages/Consultant.js